import { devtools } from 'zustand/middleware';

import { type Collectible } from '@pkg/graphql/codegen/graphql';

import { type ActiveListing } from '@app/client';
import { create } from '@app/store/zustand/helpers/create';

interface StoreTypes {
    showFilters: boolean;
    setShowFilters: (value: boolean) => void;
    isListView: boolean;
    setIsListView: (value: boolean) => void;
    isSortingDown: boolean;
    setIsSortingDown: (value: boolean) => void;
    selectedItems: string[];
    isSelectAll: boolean;
    handleSelectAll: (nftEntries: Collectible[]) => void;
    handleSelectItem: (itemId: string) => void;
    listingData?: ActiveListing;
    setListingData: (listingData: ActiveListing) => void;
}

export const useNFTsPageStore = create<StoreTypes>()(
    devtools((set) => ({
        listingData: undefined,
        showFilters: false,
        setShowFilters: (value) => set({ showFilters: value }),
        isListView: false,
        setIsListView: (value) => set({ isListView: value }),
        isSortingDown: false,
        setIsSortingDown: (value) => set({ isSortingDown: value }),
        setListingData: (listingData) => set({ listingData }),
        selectedItems: [],
        isSelectAll: false,
        handleSelectAll: (nftEntries: Collectible[]) => {
            set((state) => {
                const { isSelectAll } = state;
                const newSelectedItems = isSelectAll ? [] : nftEntries.map((item) => item.id);
                return { ...state, isSelectAll: !isSelectAll, selectedItems: newSelectedItems };
            });
        },
        handleSelectItem: (itemId: string) => {
            set((state) => {
                const { selectedItems } = state;
                const newSelectedItems = selectedItems.includes(itemId)
                    ? selectedItems.filter((id) => id !== itemId)
                    : [...selectedItems, itemId];
                return { ...state, selectedItems: newSelectedItems };
            });
        },
    })),
);
